var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){return _vm.$emit('lmBtnUpdateContentClick')}}},[_c('i',{staticClass:"mdi mdi-autorenew",class:{'lm-rotate': _vm.loading}})])
}
var staticRenderFns = []

export { render, staticRenderFns }